import { INetworkInstance } from "../../../core/api/INetworkInstance";
import { Country } from "../../../countrydetection/impl/model/Country";
import { getLogger } from "@goodgamestudios/logger";

const logger = getLogger("WorldAssignment.NetworkInstance");

export class NetworkInstance implements INetworkInstance {
    protected _type: string;

    public ip: string;
    public port: number;
    public zone: string;
    public zoneId: number;
    public instanceId: number;
    public instanceCountID: number = 0;
    public isInternational: boolean;
    public defaultcountry: string;
    public isFavorite: boolean;
    public instanceLocaId: string = "";
    public remainingRegistrationCapacity: number = 100; // this value is used to calculate capacity ratio ( specified by Zone_capacities.json) if value not available  just assume full capacity
    public serverNameWithCountry: string = "";

    public countries: Country[] = [];

    public static isTestInstance(instanceId: number): boolean {
        let TEST_SERVER_INSTANCE_ID_RANGE_START: number = 250;
        let TEST_SERVER_INSTANCE_ID_RANGE_END: number = 300;

        if (isNaN(instanceId)) {
            logger.warn("instanceId not set!");
            return false;
        }

        return instanceId >= TEST_SERVER_INSTANCE_ID_RANGE_START && instanceId <= TEST_SERVER_INSTANCE_ID_RANGE_END;
    }

    public toString(): string {
        return "ip: " + this.ip +
            ", port: " + this.port +
            ", zone: " + this.zone +
            ", zoneId: " + this.zoneId +
            ", instanceId: " + this.instanceId +
            ", instanceCountID: " + this.instanceCountID +
            ", type: " + this._type +
            ", isInternational: " + this.isInternational +
            ", defaultcountry: " + this.defaultcountry +
            ", isFavorite: " + this.isFavorite +
            ", instanceLocaId: " + this.instanceLocaId +
            ", countries: " + this.countries;
    }

    get serverName(): never {
        throw new Error("Please use Localize.text(<networkInstance>.instanceLocaId) instead of <networkInstance>.serverName");
    }


}
